import React from 'react';
import useAuthAccessQuery from 'src/hooks/useAuthAccessQuery';

interface Props {
  relation: string;
  entityType: string;
  getEntityId: () => string;
  fallback?: React.ReactNode;
}

function withAuthorizedComponent<P extends object>(
  WrappedComponent: React.ComponentType<P>,
  { relation, entityType, getEntityId, fallback = null }: Props
) {
  function ProtectedComponent(props: P) {
    const { isAllowed, isLoading } = useAuthAccessQuery({
      relation,
      entityType,
      entityId: getEntityId()
    });

    if (isLoading) {
      return <></>;
    }

    if (!isAllowed && !isLoading) {
      return <>{fallback}</>;
    }

    return <WrappedComponent {...props} />;
  }

  const wrappedComponentName =
    WrappedComponent.displayName || WrappedComponent.name || 'Component';

  // @NOTE: This is to make the component name more descriptive in React DevTools
  ProtectedComponent.displayName = `WithProtectedComponent(${wrappedComponentName})`;

  return ProtectedComponent;
}

export default withAuthorizedComponent;
